"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToPaddedHex = void 0;
function numberToPaddedHex(value) {
    let hex = value.toString(16);
    let padding = "0";
    if (hex.length % 2 == 1) {
        hex = padding + hex;
    }
    return hex;
}
exports.numberToPaddedHex = numberToPaddedHex;
//# sourceMappingURL=utils.codec.js.map